import React from 'react';
import { NavLink } from 'react-router-dom';
import './Messaging.css';

import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import FlipCard from '../../../components/FlipCards/FlipCard';
import Icon from '../../../components/Icon/Icon';

const messaging = ( props ) => {
	const card = {
		side1: 'Mattermost',
		side2: '<p><strong>Pro Tip:</strong></p><p>If you only need to chat with a couple people in a channel, start a group chat so you don\'t clog up the larger channel.</p>',
		icon: 'communication.mattermost'
	}

	const etiquetteCard = {
		side1: 'Etiquette',
		side2: '<p>Remember, using @channel is like standing up and shouting your message in the middle of the office...do you really need to send everyone an immediate notification?</p>',
		icon: 'communication.mattermost'
	}

	return (
		<section id="Messaging" className="hasCurve bg-color-2">
			<h2>Chat <span>&</span> Messaging</h2>
			<Icon icon="communication.talkBubbles" title="Chat and Messaging" />
			<div className="section">
				<FlipCard { ...card } />
				<div className="inner-section">
					<p>
						We use <a href='https://mattermost.idsi.com' target='_blank' rel='noopener noreferrer'>Mattermost</a> for chat. You should be available during working hours, so make sure you have it running each day (Hint: Download the desktop version and set it to start when you log in!). If you need to video chat or share your screen with someone, you can use Skype for Business.
					</p>
					<p>
						Mattermost uses a different password than your other IDSI accounts. <NavLink to='/super-tech-support'>Michael Magill</NavLink> will send you your initial password. Here are some tips for making the most of Mattermost:
					</p>
					<ul>
						<li>
							Download the <a href='https://mattermost.com/download/#mobile' target='_blank' rel='noopener noreferrer'>desktop client</a> instead of using the web version.
						</li>
						<li>
							Check out the pinned post on the Town Square channel for tips and tricks.
						</li>
						<li>
							Get very familiar with the notification settings (sending and receiving).
						</li>
					</ul>
				</div>
			</div>
			
			<div className="section">
				<FlipCard { ...etiquetteCard } />
				<div className="shout-icon">
					<Icon icon="communication.shout" title="Please don't shout" />
				</div>
			</div>
			
			<CurvedBottom />
		</section>
	);
};

export default messaging;



// WEBPACK FOOTER //
// ./src/pages/Communication/Messaging/Messaging.js